

























































import { Component, Prop, Vue } from "vue-property-decorator";
import PaymentInfoModal from "../components/PaymentInfoModal.vue";
import { isNewProject } from "@/preferences";
import { InvoicePayment } from "@/usecases/accounting/invoice";
import InvoiceStatus from "@/usecases/orders/invoice-status";
import InvoiceStatusTranslater from "@/usecases/orders/invoice-status-translater";
import invoiceStatus from "@/usecases/accounting/invoice-status";
import invoiceStatusTranslater from "@/usecases/accounting/invoice-status-translater";
import TextTemplateModal from "@/views/TextTemplateModal.vue";

@Component({
  components: {
    PaymentInfoModal,
    TextTemplateModal
  }
})
export default class PaymentInvoicePage extends Vue {
  @Prop({ required: true }) invoice!: InvoicePayment;

  textTemplateModalOpen: boolean = false;

  get invoiceItems() {
    return [
      { label: "請求書No", value: this.invoice.invoiceNumber },
      { label: "件名", value: this.invoice.title },
      { label: "請求担当者", value: this.invoice.staffName },
      { label: "発行日", value: this.invoice.dateOfIssue },
      { label: "入金予定日", value: this.invoice.dueDate },
      {
        label: "請求額",
        value:
          (this.invoice.total ? this.invoice.total.toLocaleString() : 0) + "円"
      }
    ];
  }

  get statusOptions() {
    if (isNewProject(this.invoice.projectCreated)) {
      return InvoiceStatus.all().map(value => ({
        value,
        text: InvoiceStatusTranslater.toJp(value)
      }));
    }

    return invoiceStatus.all().map(value => ({
      value,
      text: invoiceStatusTranslater.toJp(value)
    }));
  }

  addTextToMention(text: string) {
    if (this.invoice.note) {
      this.invoice.note += "\n";
    }
    this.invoice.note += text;
    this.textTemplateModalOpen = false;
  }

  get amountDifference() {
    return (this.invoice.total - this.invoice.amountReceived).toLocaleString();
  }

  show() {
    (this.$refs.modal as any).show();
  }

  hide() {
    (this.$refs.modal as any).hide();
  }

  getComponentStatus(created: string) {
    return isNewProject(created) ? "InvoiceStatusNew" : "InvoiceStatus";
  }

  async submitForm() {
    (this.$refs.btnSubmit as any).click();
  }

  handleSave() {
    this.$emit("saveInvoice", this.invoice);
  }
}
